import React from "react";

const CenterImage = ({ image, title, caption, width, rounded }) => {
    const imageUrl = image ? require(`../../assets/projects/${image}`) : undefined;
    const imgStyle = {
        ...(width && { maxWidth: width }),
        ...(rounded && { borderRadius: 5 })
    };

    return (
        <section className="centered-image">
            <div className="container">
                {imageUrl && <img src={imageUrl} alt={title || caption || 'A centered image'} style={imgStyle} />}
                {caption && <p>{title && <span>{title}:</span>} {caption}</p>}
            </div>
        </section>
    );
}

export default CenterImage;